export function getRouteParam(route, paramKey, queryKey = paramKey) {
  const param = route.params[paramKey];
  if (param !== undefined && param !== null && param !== '') {
    return param;
  }
  const query = route.query[queryKey];
  if (query !== undefined && query !== null && query !== '') {
    return query;
  }
  return undefined;
}

export function getRouteId(route, paramKey = 'id', queryKey = 'id') {
  return getRouteParam(route, paramKey, queryKey);
}

/** 分类页 catid：SEO 路径 param 为 id，旧 query 为 catid */
export function getRouteCatId(route) {
  return getRouteParam(route, 'id', 'catid');
}

export function getRouteType(route, defaultValue = 0) {
  const value = getRouteParam(route, 'type', 'type');
  return value !== undefined ? value : defaultValue;
}

export function getRouteActId(route) {
  return getRouteParam(route, 'actid', 'actid');
}
